import * as types from 'actions/search/types';

const initialState = {
  isLoading: false,
  query: '',
  results: null,
  isAllItemsWereLoaded: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH:
      return {
        ...state,
        isLoading: true,
        results: null,
        query: action.payload,
        isAllItemsWereLoaded: false,
      };
    case types.FETCH_SUCCESS:
      return { ...state, isLoading: false, results: action.payload };
    case types.LOAD_EXTRA_ITEMS:
      return { ...state, isLoading: true };
    case types.LOAD_EXTRA_SUCCESS:
      const { content, page } = action.payload;
      const results = { ...state.results, content: state.results.content.concat(content), page };
      return { ...state, results, isLoading: false };
    case types.LOAD_EXTRA_ERROR: {
      return { ...state, isLoading: false };
    }
    case types.LOAD_EXTRA_COMPLETED: {
      return { ...state, isAllItemsWereLoaded: true, isLoading: false };
    }
    case types.RESET_QUERY:
      return { ...state, query: '' };
    default:
      return state;
  }
};
